import { Col, Row } from 'antd'
import React from 'react'
import { Image } from 'antd';
import WeddingSection from './WeddingSection';
import AnimationIn from 'components/AnimationIn';

export default function ParrentIntroSection({ invitation }) {
    console.log(invitation)
    return <WeddingSection >
        <div
            className='no-wedding-padding-y'
            style={{
                textAlign: 'center',
                position: "relative",
                marginTop: "30px"
            }}>
            <div>
                <Image alt="flower-border-intro-parent" src="/img/parent-intro.png" width="50%" preview={false} />
            </div>

            <div style={{
                position: "relative",
                marginTop: "30px"
            }}>
                <div style={{
                    backgroundColor: "black",
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    height: "100%",
                    width: 1
                }} />
                <Row gutter={[0, 20]}>
                    <Col xs={12} className="parent-name parent-header right-align">
                        <AnimationIn animationName="fadeRight">
                            Nhà trai
                        </AnimationIn>
                    </Col>
                    <Col xs={12} className="parent-name parent-header left-align">
                        <AnimationIn animationName="fadeLeft">
                            Nhà gái
                        </AnimationIn>
                    </Col>
                </Row>

                <Row gutter={[0, 10]}>
                    <Col xs={12} className="parent-name right-align">
                        <AnimationIn animationName="fadeRight">
                            Ông Nguyễn Phước Tâm
                        </AnimationIn>
                    </Col>
                    <Col xs={12} className="parent-name left-align">
                        <AnimationIn animationName="fadeLeft">
                            Ông Nguyễn Tiến Thành
                        </AnimationIn>
                    </Col>
                </Row>

                <Row gutter={[0, 10]}>
                    <Col xs={12} className="parent-name right-align">
                        <AnimationIn animationName="fadeRight">
                            Bà Lâm Tuyết Phương
                        </AnimationIn>
                    </Col>
                    <Col xs={12} className="parent-name left-align">
                        <AnimationIn animationName="fadeLeft">
                            Bà Vương Thị Hương Giang
                        </AnimationIn>
                    </Col>
                </Row>

            </div>
            
            {invitation && 
            <div className="parent-name" style={{
                margin: "45px 0px 0px",
                fontFamily: "'Noto Serif', serif",
                fontSize: "15px",
            }}>
                <span>
                    THÂN MỜI TỚI THAM DỰ {invitation.data.both_tab === 1 ? "LỄ VU QUY & LỄ TÂN HÔN" : invitation.place.display.toUpperCase()} CỦA GIA ĐÌNH CHÚNG TÔI
                </span>
            </div>
            }

        </div>
    </WeddingSection>
}
